// From https://github.com/FuelLabs/fuel-asm/blob/eb78378c3b7c22a53b834381c387d89b3c0ef122/src/panic_reason.rs#L13
export const PANIC_REASONS = [
  'Success',
  'Revert',
  'OutOfGas',
  'TransactionValidity',
  'MemoryOverflow',
  'ArithmeticOverflow',
  'ContractNotFound',
  'MemoryOwnership',
  'NotEnoughBalance',
  'ExpectedInternalContext',
  'AssetIdNotFound',
  'InputNotFound',
  'OutputNotFound',
  'WitnessNotFound',
  'TransactionMaturity',
  'InvalidMetadataIdentifier',
  'MalformedCallStructure',
  'ReservedRegisterNotWritable',
  'ErrorFlag',
  'InvalidImmediateValue',
  'ExpectedCoinInput',
  'MaxMemoryAccess',
  'MemoryWriteOverlap',
  'ContractNotInInputs',
  'InternalBalanceOverflow',
  'ContractMaxSize',
  'ExpectedUnallocatedStack',
  'MaxStaticContractsReached',
  'TransferAmountCannotBeZero',
  'ExpectedOutputVariable',
  'ExpectedParentInternalContext',
  'IllegalJump',
  'NonZeroMessageOutputRecipient',
  'ZeroedMessageOutputRecipient',
];

export const PANIC_DOC_URL = 'https://docs.rs/fuel-asm/latest/fuel_asm/enum.PanicReason.html';
